import React, { Component } from "react";
import { HierarchicalMenu } from "react-instantsearch-dom";
import FilterSubSection from "~/scripts/components/products/FilterSubSection";

class ProductCategory extends Component {
    transformItems = items => {
        let count = 0;
        let isRefined = true;

        for (let item of items) {
            if (item.isRefined) {
                isRefined = false;
            }

            count += item.count;
        }

        items.unshift({ label: "All", value: "", count, isRefined });

        return items;
    };

    render() {
        return (
            <FilterSubSection heading="Product Type">
                <HierarchicalMenu
                    attributes={[
                        "family.categories.lvl0",
                        "family.categories.lvl1"
                    ]}
                    transformItems={this.transformItems}
                    limit={100}
                />
            </FilterSubSection>
        );
    }
}

export default ProductCategory;



// WEBPACK FOOTER //
// ./public/assets/scripts/components/products/ProductCategory.js